module.exports = __webpack_public_path__ + "assets/sp-offer-1.0b68b61c4f3184401576d7fcee9a2354.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/sp-offer-1.jpg
// module id = 604
// module chunks = 0